import { css } from "@emotion/react";
import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: mq } = mediaQueryStyles;
const { breakpoints } = constants;
const { BreakpointNames } = breakpoints;
/** Style Classes */
export const clipRowWrapperStyle = css`
  display: inline-flex;
  flex-direction: column;
  flex: 1;
  max-width: 100%;
  min-width: 100%;
  margin-bottom: 30px;
`;

export const clipRowStyle = css`
  min-width: 100%;
  display: grid;
  grid-gap: 1em;
  /* define the number of grid columns */
  grid-template-columns: repeat(1, 1fr);
  grid-auto-rows: 388px;

  ${mq.downTo(BreakpointNames.xs)} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${mq.between(BreakpointNames.md, BreakpointNames.lg)} {
    > :nth-of-type(4) {
      display: none;
    }
  }

  ${mq.downTo(BreakpointNames.md)} {
    grid-template-columns: repeat(3, 1fr);
  }

  ${mq.downTo(BreakpointNames.lg)} {
    grid-template-columns: repeat(4, 1fr);
  }
`;
